module.exports = __webpack_public_path__ + "img/file.4df42a47.svg";